// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-icon {
  position: absolute;
  top: 10px;
  right: 10px;
}

.hero {
  padding: 30px 25px 25px;
  color: var(--ion-color-main);
  text-align: left;
}
.hero h1 {
  font-family: AppFontSemiBold, sans-serif;
  font-size: 22px;
  line-height: 33px;
  text-transform: uppercase;
  margin: 10px 0px 5px;
}
.hero p {
  font-family: AppFontLight, sans-serif;
  color: rgba(47, 51, 58, 0.7);
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 15px;
}

.search-bar ion-input {
  color: var(--ion-color-main) !important;
  background: #ffffff;
}

.search-bar {
  border: 1px solid #e5e5e5;
  border-radius: 7px;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
}

.start-icon {
  margin-inline-end: 12px;
}

.search-container ion-col {
  padding: 0 !important;
  border-radius: var(--ion-border-radius);
}

.no-place {
  padding: 16px 9px;
  font-family: AppFont-bold, sans-serif;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: var(--ion-border-radius);
  font-size: 12px;
  line-height: 131.5%;
}

.suggested-place {
  border-radius: 7px;
  border: 1px solid #d5dddd;
  background: #f7f9f9;
  place-items: center;
  padding: 15px 20px;
  margin-top: 5px;
  text-align: left;
}
.suggested-place .navigate-icon {
  margin-right: 15px;
  fill: var(--ion-color-primary) !important;
}
.suggested-place .actual-position-title {
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  font-family: AppFontSemiBold, sans-serif;
}
.suggested-place .actual-position {
  font-size: 13px;
  margin-top: 5px;
  line-height: 16px;
  color: #6d7075;
  font-family: AppFontLight, sans-serif;
}

#buttonContainer {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.vertical-space-around {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.cnt-btn {
  width: 100%;
  padding: 16px;
  text-align: center;
  font-family: AppFontBold, sans-serif;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  margin: 0;
  background: var(--ion-color-primary);
  border-radius: 50px;
}
@media (min-width: 991px) {
  .cnt-btn {
    margin: auto;
  }
}

.geo-btn {
  background: #62aba4;
  font-family: AppFont-bold, sans-serif;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  padding: 16px;
  text-align: center;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
}
.geo-btn ion-icon {
  width: 22px;
  height: 25px;
  margin-right: 10px;
}
@media (min-width: 991px) {
  .geo-btn {
    width: 600px;
    margin: auto;
  }
}

.heading-text {
  font-size: 19px;
  color: var(--ion-text-color);
  font-weight: 500;
  line-height: 145%;
  margin: 20px 0 10px;
}
.heading-text.desktop {
  display: block;
}
@media (max-width: 992px) {
  .heading-text.desktop {
    display: none;
  }
}
.heading-text.mobile {
  display: none;
}
@media (max-width: 992px) {
  .heading-text.mobile {
    display: block;
  }
}

.sub-heading {
  font-size: 18px;
  line-height: 134%;
  margin: 0;
}

.footer-btn {
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  color: white;
}

ion-footer,
.footer-btn {
  background: unset;
  padding: 5px 28px 5px !important;
  box-shadow: none;
}
@media (min-width: 991px) {
  ion-footer,
  .footer-btn {
    margin: 0px 50px 0 !important;
    width: calc(100% - 100px) !important;
  }
}
ion-footer .button,
.footer-btn .button {
  flex: 1;
  background: var(--ion-color-primary) !important;
  color: white !important;
  text-align: center;
}
ion-footer .button:first-child,
.footer-btn .button:first-child {
  margin-right: 3px;
}
ion-footer .button:last-child,
.footer-btn .button:last-child {
  margin-left: 3px;
}
ion-footer .button.active,
.footer-btn .button.active {
  transition: 0.3s linear;
  background: var(--ion-color-main);
  color: var(--ion-text-color);
}
ion-footer .button.active:hover,
.footer-btn .button.active:hover {
  transition: 0.3s linear;
  background: var(--ion-color-main);
}

.desktop {
  display: none;
  margin: 50px 25px;
}
@media (min-width: 991px) {
  .desktop {
    display: block;
  }
}
.desktop .hero {
  background: white;
  border: 0.5px solid #e5e5e5;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
  border-radius: 10px;
}

.mobile {
  display: none;
}
@media (max-width: 992px) {
  .mobile {
    display: block;
  }
}

.logo-block {
  width: 100%;
  display: flex;
  justify-content: center;
}
.logo-block ion-icon {
  width: 40%;
  height: 60px;
}
@media (max-width: 992px) {
  .logo-block {
    width: 100%;
    height: 40px;
    margin-bottom: 24px;
  }
}

@media (min-width: 991px) {
  .desktop-hero {
    text-align: center;
    margin: 0px 25px 50px;
  }
}

.cross-icon-close {
  position: absolute;
  top: 10px;
  right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/check-delivery-radius-modal/check-delivery-radius-modal.component.scss"],"names":[],"mappings":"AAWA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;AAVD;;AAaA;EACC,uBAAA;EACA,4BAAA;EACA,gBAAA;AAVD;AAWC;EACC,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;AATF;AAWC;EACC,qCAAA;EACA,4BAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AATF;;AAaA;EACC,uCAAA;EACA,mBAAA;AAVD;;AAYA;EACC,yBAAA;EACA,kBAAA;AATD;;AAYA;EACC,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AATD;;AAWA;EACC,uBAAA;AARD;;AAWA;EACC,qBAAA;EACA,uCAAA;AARD;;AAWA;EACC,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;AARD;;AAWA;EACC,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AARD;AASC;EACC,kBAAA;EACA,yCAAA;AAPF;AAUC;EACC,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,+BAAA;EACA,wCAAA;AARF;AAWC;EACC,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,qCAAA;AATF;;AAaA;EACC,kBAAA;EACA,WAAA;EACA,SAAA;AAVD;;AAaA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AAVD;;AAaA;EACC,WAAA;EACA,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,iBAAA;EAEA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,oCAAA;EACA,mBAAA;AAXD;AAnHC;EAkHD;IAcE,YAAA;EATA;AACF;;AAYA;EACC,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EAEA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAVD;AAYC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AAVF;AA5IC;EAoID;IAsBE,YAAA;IACA,YAAA;EAVA;AACF;;AAaA;EACC,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAVD;AAYC;EACC,cAAA;AAVF;AAvJC;EAgKA;IAGE,aAAA;EARD;AACF;AAWC;EACC,aAAA;AATF;AA/JC;EAuKA;IAGE,cAAA;EAPD;AACF;;AAWA;EACC,eAAA;EACA,iBAAA;EACA,SAAA;AARD;;AAWA;EACC,oCAAA;EACA,yBAAA;EACA,YAAA;AARD;;AAWA;;EAEC,iBAAA;EACC,gCAAA;EACD,gBAAA;AARD;AA7LC;EAiMD;;IAOE,6BAAA;IACA,oCAAA;EANA;AACF;AAQC;;EACC,OAAA;EACA,+CAAA;EACA,uBAAA;EACA,kBAAA;AALF;AAOE;;EACC,iBAAA;AAJH;AAOE;;EACC,gBAAA;AAJH;AAOE;;EACC,uBAAA;EACA,iCAAA;EACA,4BAAA;AAJH;AAMG;;EACC,uBAAA;EACA,iCAAA;AAHJ;;AAQA;EACC,aAAA;EAKA,iBAAA;AATD;AAnOC;EAsOD;IAGE,cAAA;EAFA;AACF;AAKC;EACC,iBAAA;EACA,2BAAA;EACA,+CAAA;EACA,mBAAA;AAHF;;AAMA;EACC,aAAA;AAHD;AA5OC;EA8OD;IAGE,cAAA;EADA;AACF;;AAGA;EACC,WAAA;EACA,aAAA;EACA,uBAAA;AAAD;AACC;EACC,UAAA;EACA,YAAA;AACF;AA3PC;EAoPD;IASE,WAAA;IACM,YAAA;IACA,mBAAA;EAEN;AACF;;AAxQC;EAwQD;IAEE,kBAAA;IACA,qBAAA;EAGA;AACF;;AAGA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;AAAD","sourcesContent":["@mixin desktop {\n\t@media (min-width: 991px) {\n\t\t@content;\n\t}\n}\n\n@mixin mobile {\n\t@media (max-width: 992px) {\n\t\t@content;\n\t}\n}\n.close-icon {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n}\n\n.hero {\n\tpadding: 30px 25px 25px;\n\tcolor: var(--ion-color-main);\n\ttext-align: left;\n\th1 {\n\t\tfont-family: AppFontSemiBold, sans-serif;\n\t\tfont-size: 22px;\n\t\tline-height: 33px;\n\t\ttext-transform: uppercase;\n\t\tmargin: 10px 0px 5px;\n\t}\n\tp {\n\t\tfont-family: AppFontLight, sans-serif;\n\t\tcolor: rgba(47, 51, 58, 0.7);\n\t\tfont-size: 14px;\n\t\tmargin-top: 5px;\n\t\tmargin-bottom: 15px;\n\t}\n}\n\n.search-bar ion-input {\n\tcolor: var(--ion-color-main) !important;\n\tbackground: #ffffff;\n}\n.search-bar {\n\tborder: 1px solid #e5e5e5;\n\tborder-radius: 7px;\n}\n\n.search-bar > div {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: row;\n\tplace-items: center;\n}\n.start-icon {\n\tmargin-inline-end: 12px;\n}\n\n.search-container ion-col {\n\tpadding: 0 !important;\n\tborder-radius: var(--ion-border-radius);\n}\n\n.no-place {\n\tpadding: 16px 9px;\n\tfont-family: AppFont-bold, sans-serif;\n\tbackground: #ffffff;\n\tbox-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n\tborder-radius: var(--ion-border-radius);\n\tfont-size: 12px;\n\tline-height: 131.5%;\n}\n\n.suggested-place {\n\tborder-radius: 7px;\n\tborder: 1px solid #d5dddd;\n\tbackground: #f7f9f9;\n\tplace-items: center;\n\tpadding: 15px 20px;\n\tmargin-top: 5px;\n\ttext-align: left;\n\t.navigate-icon {\n\t\tmargin-right: 15px;\n\t\tfill: var(--ion-color-primary) !important;\n\t}\n\n\t.actual-position-title {\n\t\tfont-size: 14px;\n\t\tline-height: 17px;\n\t\ttext-transform: uppercase;\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-family: AppFontSemiBold, sans-serif;\n\t}\n\n\t.actual-position {\n\t\tfont-size: 13px;\n\t\tmargin-top: 5px;\n\t\tline-height: 16px;\n\t\tcolor: #6d7075;\n\t\tfont-family: AppFontLight, sans-serif;\n\t}\n}\n\n#buttonContainer {\n\tposition: absolute;\n\twidth: 100%;\n\tbottom: 0;\n}\n\n.vertical-space-around {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-around;\n\talign-items: center;\n}\n\n.cnt-btn {\n\twidth: 100%;\n\tpadding: 16px;\n\ttext-align: center;\n\tfont-family: AppFontBold, sans-serif;\n\tcolor: white;\n\tfont-weight: bold;\n\n\ttext-transform: uppercase;\n\tcursor: pointer;\n\tmargin: 0;\n\tbackground: var(--ion-color-primary);\n\tborder-radius: 50px;\n\t@include desktop {\n\t\tmargin: auto;\n\t}\n}\n\n.geo-btn {\n\tbackground: #62aba4;\n\tfont-family: AppFont-bold, sans-serif;\n\tcolor: #ffffff;\n\tfont-weight: bold;\n\tcursor: pointer;\n\twidth: 100%;\n\tpadding: 16px;\n\ttext-align: center;\n\n\ttext-transform: uppercase;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tion-icon {\n\t\twidth: 22px;\n\t\theight: 25px;\n\t\tmargin-right: 10px;\n\t}\n\n\t@include desktop {\n\t\twidth: 600px;\n\t\tmargin: auto;\n\t}\n}\n\n.heading-text {\n\tfont-size: 19px;\n\tcolor: var(--ion-text-color);\n\tfont-weight: 500;\n\tline-height: 145%;\n\tmargin: 20px 0 10px;\n\n\t&.desktop {\n\t\tdisplay: block;\n\t\t@include mobile() {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t&.mobile {\n\t\tdisplay: none;\n\t\t@include mobile() {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n\n.sub-heading {\n\tfont-size: 18px;\n\tline-height: 134%;\n\tmargin: 0;\n}\n\n.footer-btn {\n\tfont-family: AppFontBold, sans-serif;\n\ttext-transform: uppercase;\n\tcolor: white;\n}\n\nion-footer,\n.footer-btn {\n\tbackground: unset;\n  padding: 5px 28px 5px !important;\n\tbox-shadow: none;\n\n\t@include desktop {\n\t\tmargin: 0px 50px 0 !important;\n\t\twidth: calc(100% - 100px) !important;\n\t}\n\n\t.button {\n\t\tflex: 1;\n\t\tbackground: var(--ion-color-primary) !important;\n\t\tcolor: white !important;\n\t\ttext-align: center;\n\n\t\t&:first-child {\n\t\t\tmargin-right: 3px;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tmargin-left: 3px;\n\t\t}\n\n\t\t&.active {\n\t\t\ttransition: 0.3s linear;\n\t\t\tbackground: var(--ion-color-main);\n\t\t\tcolor: var(--ion-text-color);\n\n\t\t\t&:hover {\n\t\t\t\ttransition: 0.3s linear;\n\t\t\t\tbackground: var(--ion-color-main);\n\t\t\t}\n\t\t}\n\t}\n}\n.desktop {\n\tdisplay: none;\n\t@include desktop() {\n\t\tdisplay: block;\n\t}\n\n\tmargin: 50px 25px;\n\t.hero {\n\t\tbackground: white;\n\t\tborder: 0.5px solid #e5e5e5;\n\t\tbox-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n\t\tborder-radius: 10px;\n\t}\n}\n.mobile {\n\tdisplay: none;\n\t@include mobile() {\n\t\tdisplay: block;\n\t}\n}\n.logo-block {\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\tion-icon {\n\t\twidth: 40%;\n\t\theight: 60px;\n\t}\n\t@include mobile {\n\t\twidth: 100%;\n        height: 40px;\n        margin-bottom: 24px;\n\t}\n}\n.desktop-hero {\n\t@include desktop() {\n\t\ttext-align: center;\n\t\tmargin: 0px 25px 50px;\n\t}\n}\n// .cross {\n//   fill: var(--ion-color-primary) !important;\n// }\n\n.cross-icon-close {\n\tposition: absolute;\n\ttop: 10px;\n\tright: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
